export { IssuePage as default } from '@/components/pages/Ir/Manage/Issue'
